/*
* Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
  distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
  prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
  content, please contact the author for proper authorization and agreement.
  */
import React from 'react'
import { withTranslation, type WithTranslation } from 'react-i18next'

type TProps = WithTranslation & {
  children: React.ReactNode
}

const T: React.FC<TProps> = (props) => {
  const key = String(props.children)
  return <span>{props.t(key)}</span>
}

export default withTranslation()(T)
